import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aebac580"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-lines" }
const _hoisted_2 = ["d", "stroke"]

import { computed } from 'vue'
import tinycolor from 'tinycolor2'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { VIEWPORT_SIZE } from '@/configs/canvas'
import { SlideBackground } from '@/types/slides'


export default /*#__PURE__*/_defineComponent({
  __name: 'GridLines',
  setup(__props) {

const { canvasScale, gridLineSize } = storeToRefs(useMainStore())
const { currentSlide, viewportRatio } = storeToRefs(useSlidesStore())

const background = computed<SlideBackground | undefined>(() => currentSlide.value?.background)

// 计算网格线的颜色，避免与背景的颜色太接近
const gridColor = computed(() => {
  const bgColor = background.value?.color || '#fff'
  const colorList = ['#000', '#fff']
  return tinycolor.mostReadable(bgColor, colorList, { includeFallbackColors: true }).setAlpha(.5).toRgbString()
})

// 网格路径
const path = computed(() => {
  const maxX = VIEWPORT_SIZE
  const maxY = VIEWPORT_SIZE * viewportRatio.value

  let p = ''
  for (let i = 0; i <= Math.floor(maxY / gridLineSize.value); i++) {
    p += `M0 ${i * gridLineSize.value} L${maxX} ${i * gridLineSize.value} `
  }
  for (let i = 0; i <= Math.floor(maxX / gridLineSize.value); i++) {
    p += `M${i * gridLineSize.value} 0 L${i * gridLineSize.value} ${maxY} `
  }
  return p
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      style: _normalizeStyle({
        transform: `scale(${_unref(canvasScale)})`,
      }),
      d: _unref(path),
      fill: "none",
      stroke: _unref(gridColor),
      "stroke-width": "0.3",
      "stroke-dasharray": "5"
    }, null, 12, _hoisted_2)
  ]))
}
}

})